import ChattyDebugCollector from '@assets/services/ChattyDebugCollector';

export default function initDebugCollector() {
  return new ChattyDebugCollector();
}
